import './style.scss';

import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { IoMdClose } from 'react-icons/io';
import { LuCalendar, LuClock, LuMapPin, LuUser, LuVideo } from 'react-icons/lu';
import { ReactSVG } from 'react-svg';

import SyncIcon from 'assets/images/sync.svg';

import { Button, Text } from 'pctComponents/atoms';
import useModalOverflowHidden from 'pctHooks/useModalOverflowHidden';
import {
    MeetingItem,
    formatModalDate,
    formatModalTime,
    getMeetingTitle,
    getRecurrenceDescription,
    isOnline,
    isPastMeeting,
    isRecurrent,
    withProtocol,
} from 'pctComponents/organisms/Meeting/utils';

export type ModalMeetingDetailsProps = {
    obj: {
        meeting: MeetingItem;
        fallbackTitle?: string;
    };
    onClose?: () => void;
};

const ModalMeetingDetails = NiceModal.create(({ obj, onClose }: ModalMeetingDetailsProps) => {
    const modal = useModal();
    const { meeting, fallbackTitle = '' } = obj;

    useModalOverflowHidden(modal);

    const online = isOnline(meeting);
    const past = isPastMeeting(meeting);
    const recurrenceDescription = isRecurrent(meeting) ? getRecurrenceDescription(meeting) : '';

    const closeModal = () => {
        modal.remove();

        if (onClose) {
            onClose();
        }
    };

    const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            closeModal();
        }
    };

    return (
        <div className="modalMeetingDetails" onClick={handleOverlayClick}>
            <div className="modalMeetingDetailsBody">
                <button type="button" className="closeBtn" onClick={closeModal} aria-label="Fechar">
                    <IoMdClose />
                </button>

                <Text component="h2" text={getMeetingTitle(meeting, fallbackTitle)} className="title" />

                <ul className="meetingInfoList">
                    <li>
                        <LuCalendar />
                        <Text component="p" text={formatModalDate(meeting)} />
                    </li>

                    <li>
                        <LuClock />
                        <Text component="p" text={formatModalTime(meeting)} />
                    </li>

                    {!!meeting.address &&
                        (online ? (
                            <li>
                                <LuVideo />
                                {past ? (
                                    <span className="roomAccessDisabled" aria-disabled="true">
                                        Entrar na sala
                                    </span>
                                ) : (
                                    <a
                                        className="roomAccess"
                                        href={withProtocol(meeting.address)}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Entrar na sala
                                    </a>
                                )}
                            </li>
                        ) : (
                            <li>
                                <LuMapPin />
                                <Text component="p" text={meeting.address} />
                            </li>
                        ))}

                    {!!meeting.speaker && (
                        <li>
                            <LuUser />
                            <Text component="p" text={`Condutor: ${meeting.speaker}`} />
                        </li>
                    )}

                    {!!recurrenceDescription && (
                        <li>
                            <ReactSVG src={SyncIcon} className="recurrenceIcon" />
                            <Text component="p" text={recurrenceDescription} />
                        </li>
                    )}
                </ul>

                <Button text="Fechar" className="button06 closeButton" callEvent={closeModal} />
            </div>
        </div>
    );
});

export default ModalMeetingDetails;
